// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M9.16602 3.33027H5.66602C4.26588 3.33027 3.56582 3.33027 3.03104 3.60275C2.56063 3.84244 2.17818 4.22489 1.9385 4.69529C1.66602 5.23007 1.66602 5.93014 1.66602 7.33027V14.3303C1.66602 15.7304 1.66602 16.4305 1.9385 16.9652C2.17818 17.4356 2.56063 17.8181 3.03104 18.0578C3.56582 18.3303 4.26588 18.3303 5.66602 18.3303H12.666C14.0661 18.3303 14.7662 18.3303 15.301 18.0578C15.7714 17.8181 16.1538 17.4356 16.3935 16.9652C16.666 16.4305 16.666 15.7304 16.666 14.3303V10.8303M6.66599 13.3303H8.06145C8.4691 13.3303 8.67292 13.3303 8.86474 13.2842C9.0348 13.2434 9.19737 13.176 9.34649 13.0847C9.51468 12.9816 9.65881 12.8375 9.94706 12.5492L17.916 4.58027C18.6064 3.88991 18.6064 2.77062 17.916 2.08027C17.2257 1.38991 16.1064 1.38991 15.416 2.08027L7.44704 10.0492C7.15879 10.3375 7.01466 10.4816 6.91159 10.6498C6.82021 10.7989 6.75287 10.9615 6.71204 11.1315C6.66599 11.3234 6.66599 11.5272 6.66599 11.9348V13.3303Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconUserEditPencil = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUserEditPencil;
